import React, { FC } from "react";
import { Col, Row} from "antd";
import styled from "styled-components";
import FooterPublic3D from "../../Components/FooterPublic3D";
import {
  ExpertText,
  MediumHeaderTitle,
} from "../../Components/Text3D";
import HeaderComponent from "../../Components/HeaderComponents";

const PrivacyContainer = styled.div`
  display: flex;
  font-family: "Rogan";
  flex-direction: column;
  width: "100%";
  ul {
    list-style-type: none;
  }
`;

const PrivacyPolicyScreen: FC = () => {
  return (
    <>
      <PrivacyContainer>
        <HeaderComponent />
        <Col
          style={{ marginBottom: "1remx", marginTop: "2em" }}
          lg={{ span: 20, offset: 2 }}
          md={{ span: 20, offset: 2 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Row>
            <Col>
              <MediumHeaderTitle dark> Privacy Policy</MediumHeaderTitle>
              <ExpertText
                dark
                style={{ fontSize: "20px", wordSpacing: 2, lineHeight: "30px" }}
              >
                Effective Date: 22/04/2023 <br />
                <br />
                3Dprintit.net ("we", "us", or "our") values your privacy and is
                committed to protecting your personal information. This Privacy
                Policy explains how we collect, use, and disclose your personal
                information when you use our customer-to-customer marketplace
                for 3D printing services (the "Marketplace"). <br />
                <br />
                By accessing and using the Marketplace, you agree to the terms
                of this Privacy Policy. If you do not agree with this policy,
                please do not use the Marketplace.
              </ExpertText>

              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                A. Information We Collect
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                We collect various types of personal information from users to
                provide the best possible experience on the Marketplace. The
                information we collect includes:
              </ExpertText>
              <ul>
                <li>
                  <ExpertText dark>
                    {" "}
                    a) Account Information: When you create an account on the
                    Marketplace, we collect your full name, email address,
                    mailing address, username, and password.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    b) Transaction Information: When you engage in transactions
                    through the Marketplace, we collect information about your
                    orders, including the 3D printing service provider, the item
                    purchased, the price, and the transaction date.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    c) Payment Information: We use a third-party payment
                    processor to process payments for transactions on the
                    Marketplace. Although we do not directly collect or store
                    your credit card or banking information, we receive certain
                    transaction details from our payment processor.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    d) Communications: When you communicate with us or other
                    users through the Marketplace, we may collect the contents
                    of your messages and any attachments.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    e) Usage Information: We automatically collect certain
                    information about your usage of the Marketplace, such as
                    your IP address, browser type, device information, pages
                    visited, and the date and time of your visit.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    f) Cookies and Similar Technologies: We use cookies and
                    similar technologies to collect information about your
                    interactions with the Marketplace, and to provide a
                    personalized experience.
                  </ExpertText>
                </li>
              </ul>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                B. How We Use Your Information
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                We use the personal information we collect for the following
                purposes:
              </ExpertText>
              <ul>
                <li>
                  <ExpertText dark>
                    {" "}
                    a) To provide, maintain, and improve the Marketplace.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    b) To facilitate transactions between you and other users.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    c) To communicate with you about your account, transactions,
                    or other Marketplace-related matters.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    d) To provide customer support and resolve issues.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    e) To analyze usage trends and optimize the user experience.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    f) To detect, prevent, and investigate fraudulent or illegal
                    activities.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    g) To enforce our terms of service and this Privacy Policy.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    {" "}
                    h) To comply with applicable laws and regulations.
                  </ExpertText>
                </li>
              </ul>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                C. How We Share Your Information
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                We may share your personal information in the following
                circumstances:
              </ExpertText>
              <ul>
                <li>
                  <ExpertText dark>
                  a) With other users of the Marketplace to facilitate
                  transactions and communications.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                  b) With third-party service providers who perform services on
                  our behalf, such as payment processing and customer support.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                  c) In response to legal requests, such as subpoenas, court
                  orders, or government investigations.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                  d) In connection with a merger, acquisition, or sale of assets
                  involving [COMPANY NAME].
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    e) With your consent or at your direction.
                  </ExpertText>
                </li>
              </ul>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                D. Data Retention and Security
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                We retain your personal information for as long as necessary to
                provide the Marketplace and for other purposes outlined in this
                Privacy Policy. We maintain appropriate technical and
                organizational measures to protect your personal information
                from unauthorized access, disclosure, alteration, or
                destruction.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                E. Third-Party Links and Services
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                The Marketplace may contain links to third-party websites and
                services. We are not responsible for the privacy practices of
                these third parties, and we encourage you to review their
                privacy policies before providing them with your personal
                information.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                F. Children's Privacy
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                The Marketplace is not intended for use by individuals under the
                age of 13. We do not knowingly collect personal information from
                children under 13. If we learn that we have collected personal
                information from a child under 13, we will delete that
                information as soon as possible.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                G. International Data Transfers
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                Your personal information may be transferred to and processed in
                countries other than your residence, including the United
                States, where we and our service providers maintain servers and
                facilities. By using the Marketplace, you consent to the
                transfer, storage, and processing of your personal information
                in these countries. We will take appropriate steps to ensure
                that your personal information is treated securely and in
                accordance with this Privacy Policy and applicable data
                protection laws.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                H. Changes to This Privacy Policy
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or applicable laws. If we make material
                changes to this Privacy Policy, we will notify you by posting a
                notice on the Marketplace or by sending an email to the address
                associated with your account. Your continued use of the
                Marketplace following such notice constitutes your acceptance of
                the updated Privacy Policy.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                I. Your Rights and Choices
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                Depending on your location and applicable data protection laws,
                you may have certain rights regarding your personal information.
                These rights may include the right to access, correct, or delete
                your personal information, as well as the right to object to or
                restrict our processing of your personal information. To
                exercise these rights, please contact us at [email address]. We
                will respond to your request within a reasonable timeframe and
                in accordance with applicable laws.
              </ExpertText>
              <MediumHeaderTitle
                dark
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                {" "}
                J. Contact Us
              </MediumHeaderTitle>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                If you have any questions or concerns about this Privacy Policy
                or our privacy practices, please contact us at:
                <br />
                <br />
                3Dprintit.net <br />
                608 Harris St
                <br /> Ultimo, NSW, 2007 <br />
                Australia <br />
                Email: help@3dprintit.net
                <br />
                <br />
                Last updated: 22/04/2023
              </ExpertText>
            </Col>
          </Row>
        </Col>
        <FooterPublic3D />
      </PrivacyContainer>
    </>
  );
};

export default PrivacyPolicyScreen;
